import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from "primereact/dropdown";


const ExamMarksEntry = (props) => {
    const { catchResponse } = useCatchResponse();
    const [students, setStudents] = useState([]);
    const navigate = useNavigate();
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [securityUserID, setSecurityUserID] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [gradeList, setGradeList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        StudentName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ExamName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        RollNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetGradeList(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
        GetExamMarksList(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
    }, []);

    const GetGradeList = async (id) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: props?.location?.state?.financialYearId
            }
            await api.post(APIConstant.path.getGradeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let gradeData = res?.data
                        ?.filter((y) => !y?.IsCoScholastic);
                    gradeData = gradeData?.flatMap((x) =>
                        x?.GradeTemplateValues?.map((valueItem) => ({
                            value: valueItem?._id || x?._id,
                            label: valueItem?.GradeName || x?.GradeTemplateName,
                        }))
                    );
                    setGradeList(gradeData);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const GetExamMarksList = async (id) => {
        try {
            let data = {
                ClassId: props?.location?.state?.classId,
                ExamTypeId: props?.location?.state?.examId,
                SubjectId: props?.location?.state?.subjectId,
                TermId: props?.location?.state?.termId,
                UserID: id,
                FinancialYearId: props?.location?.state?.financialYearId
            }
            await api.post(APIConstant.path.GetExamMarksList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let sortedList = res?.data ? res?.data?.sort((a, b) => (parseInt(a?.RollNo) || 0) - (parseInt(b?.RollNo) || 0)) : [];
                    setStudents(sortedList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const AddExamMarksData = async (isGraft) => {
        try {
            const updatedStudents = students?.map((student) => (
                { ...student, IsGraft: isGraft, FinancialYearId: props?.location?.state?.financialYearId, CreatedBy: securityUserID })
            );
            Loader.show();
            await api.post(APIConstant.path.AddUpdateExamMarks, updatedStudents).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: res.message });
                    Loader.hide();
                    navigate('/examination');
                } else {
                    Loader.hide();
                    Toast.error({ message: res.message });
                }
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.data?.message });
                console.log('error in catch: ', err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const handleMarksChange = (e, index) => {
        const numericValue = e.target.value.replace(/[^0-9]/g, '');

        setStudents((prev) => {
            const updated = [...prev];

            const enteredMarks = Number(numericValue);
            const totalMarks = Number(updated[index].TotalMarks);

            updated[index] = {
                ...updated[index],
                SecuredMarks:
                    enteredMarks > totalMarks ? 0 : enteredMarks
            };

            return updated;
        });
    };

    const handleGradeMarksChange = (value, index) => {
         setStudents((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                SecuredMarks:value
            };

            return updated;
        });
    };

    const marksEditor = (rowData, options) => {
        if (props?.location?.state?.isGradeAllow) {
            return (
                <Dropdown
                    disabled={
                        !props?.location?.state?.isAllow || gradeList.length === 0
                    }
                    value={rowData?.SecuredMarks}
                    options={gradeList}
                    onChange={(e) => handleGradeMarksChange(e.value, options?.rowIndex)}
                    placeholder={gradeList.length == 0 ? "Loading..." : "Select Grade"}
                    className="p-w-100 p-mt-1"
                    filter
                    showClear
                />
            );
        } else {
            return (
                <InputText
                    disabled={!props?.location?.state?.isAllow}
                    value={rowData?.SecuredMarks}
                    onChange={(e) => handleMarksChange(e, options?.rowIndex)}
                    style={{ width: "60px", textAlign: "center" }}
                />
            );
        }
    };

    const srNoBodyTemplate = (rowData, props) => {
        return (
            <div>
                {CommonConfig.isEmpty(rowData?.SecuredMarks) || rowData?.SecuredMarks == 0
                    ? (
                        <>
                            {props?.rowIndex + 1}
                            <span style={{ color: "red" }}>*</span>
                        </>
                    )
                    : props?.rowIndex + 1}
            </div>
        );
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-arrow-left" onClick={(e) => navigate('/examination')}></i>
                    <h2>{`${props?.location?.state?.className}-${props?.location?.state?.sectionName}`} / {props?.location?.state?.subjectName}</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <hr className='p-m-0' />
            <DataTable
                key={props?.location?.state?.isGradeAllow ? gradeList.length : "marks"}
                value={students}
                paginator
                dataKey="StudentId"
                rows={rows}
                first={first}
                filters={filters}
                responsiveLayout="scroll"
                globalFilterFields={['RollNo', 'ExamName', 'StudentName']}
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 180px)'
                size='small'
            >
                <Column header="Sr No" body={srNoBodyTemplate} style={{ width: "10%" }} />
                <Column field="StudentName" header="Name" style={{ width: "25%" }} />
                <Column field="ExamName" header="Exam Name" style={{ width: "25%" }} />
                <Column field="GrNo" header="GR No." style={{ width: "15%" }} />
                <Column field="RollNo" header="Roll No." style={{ width: "15%" }} />
                {!props?.location?.state?.isGradeAllow &&
                    <Column field="TotalMarks" header="Total Marks" style={{ width: "15%" }} />}
                {!props?.location?.state?.isGradeAllow && <Column field="MinMark" header="Min Marks" style={{ width: "15%" }} />}
                <Column header={!props?.location?.state?.isGradeAllow ? "Secured Marks" : "Secured Grade"} body={marksEditor} style={{ width: "20%" }} />
            </DataTable>
            <div className="p-d-flex p-jc-end p-ai-center p-mt-3 p-pr-3" style={{ gap: '1rem' }}>
                <Button label="Cancel" onClick={(e) => navigate('/examination')} className="p-button-outlined p-button-secondary" />
                {props?.location?.state?.isAllow &&
                    <React.Fragment>
                        <Button label="Save as Draft" className="p-button-secondary" onClick={(e) => AddExamMarksData(true)} />
                        <Button label="Submit All" className="p-button-primary" onClick={(e) => AddExamMarksData(false)} />
                    </React.Fragment>}
            </div>
        </div>
    );
};

export default ExamMarksEntry;
